import Field from "../../../DesignSystem/Inputs/Field";
import CheckboxMultiSelect from "../../../DesignSystem/Dropdowns/CheckboxMultiSelect";
import { normaliseStatementEmails, statementRecipientEmails } from "../../../Adviser/Tabs/Rates/statementRecipients";
import GroupBankDetailsEditLogs from "./GroupBankDetailsEditLogs";

export default function BankStatementDetails({
  selectedGroup,
  selectedSavedGroup,
  canEditBankDetails,
  editingBankDetails,
  setEditingBankDetails,
  bankForm,
  effectiveStatementPassword,
  updateBankField,
  groupStatementRecipientOptions,
  savingBankDetails,
  handleSaveBankDetails,
  bankMessage,
  bankError
}) {
  return (
                <>
              <div className="smPost">
                <div className="smPostHeader">
                  <div className="smPostTitle Content-SemiBold">
                    Bank & Statement Details
                  </div>
                  {canEditBankDetails ? <button
                    type="button"
                    className="btn Content-Small"
                    onClick={() => setEditingBankDetails((current) => !current)}
                  >
                    {editingBankDetails ? "Cancel" : "Edit bank and statement details"}
                  </button> : null}
                </div>

                {editingBankDetails && canEditBankDetails ? (
                  <div className="smGrid2">
                    <div className="smField">
                      <label className="smFieldLabel Content-Small">
                        Sort Code
                      </label>
                      <input
                        className="smFieldInput"
                        type="text"
                        value={bankForm.arSortCode}
                        placeholder="00-00-00"
                        maxLength={8}
                        inputMode="numeric"
                        onChange={(event) =>
                          updateBankField("arSortCode", event.target.value)
                        }
                      />
                    </div>
                    <div className="smField">
                      <label className="smFieldLabel Content-Small">
                        Account Number
                      </label>
                      <input
                        className="smFieldInput"
                        type="text"
                        value={bankForm.arAccountNumber}
                        placeholder="xxxxxxxx"
                        maxLength={8}
                        inputMode="numeric"
                        onChange={(event) =>
                          updateBankField("arAccountNumber", event.target.value)
                        }
                      />
                    </div>
                    <div className="smField smFieldFull">
                      <label className="smFieldLabel Content-Small">
                        Account Holder
                      </label>
                      <input
                        className="smFieldInput"
                        type="text"
                        value={bankForm.arAccountHolder}
                        placeholder="Account Name"
                        onChange={(event) =>
                          updateBankField("arAccountHolder", event.target.value)
                        }
                      />
                    </div>
                    <div className="smFieldFull">
                      <div className="FP_Body_Semibold">Statement Details</div>
                    </div>
                    <div className="smFieldFull">
                      <CheckboxMultiSelect
                        label="To"
                        options={groupStatementRecipientOptions}
                        value={statementRecipientEmails(
                          bankForm.emailCommissionStatementsTo,
                        )}
                        placeholder="Select recipients"
                        helperText="Select one or more recipients"
                        onChange={(value) =>
                          updateBankField(
                            "emailCommissionStatementsTo",
                            normaliseStatementEmails(value),
                          )
                        }
                      />
                    </div>
                    <Field
                      label="CC"
                      type="text"
                      value={bankForm.emailCommissionStatementsCc}
                      placeholder="Email addresses separated by commas"
                      full
                      onChange={(value) =>
                        updateBankField("emailCommissionStatementsCc", value)
                      }
                    />
                    <Field
                      label="Statement Password"
                      type="password"
                      showPasswordToggle
                      value={effectiveStatementPassword}
                      placeholder="Uses the fixed fallback password"
                      full
                      onChange={(value) =>
                        updateBankField("statementPassword", value)
                      }
                    />
                    <p className="Content-Small muted smFieldFull">
                      If left blank, the first selected adviser recipient&apos;s
                      saved statement password or date of birth will be used.
                    </p>
                    <div className="profileActionsRow">
                      <button
                        type="button"
                        className="btn Content-Small"
                        disabled={savingBankDetails}
                        onClick={handleSaveBankDetails}
                      >
                        {savingBankDetails
                          ? "Saving..."
                          : "Save bank and statement details"}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="smGrid2">
                    <div className="smRow">
                      <div className="smRowLabel Content-Small">Sort Code</div>
                      <div className="smRowValue Content">
                        {selectedSavedGroup?.bankDetails?.arSortCode || "-"}
                      </div>
                    </div>
                    <div className="smRow">
                      <div className="smRowLabel Content-Small">
                        Account Number
                      </div>
                      <div className="smRowValue Content">
                        {selectedSavedGroup?.bankDetails?.arAccountNumber || "-"}
                      </div>
                    </div>
                    <div className="smRow">
                      <div className="smRowLabel Content-Small">
                        Account Holder
                      </div>
                      <div className="smRowValue Content">
                        {selectedSavedGroup?.bankDetails?.arAccountHolder || "-"}
                      </div>
                    </div>
                    <div className="smRow smFieldFull">
                      <div className="smRowLabel Content-Small">To</div>
                      <div className="smRowValue Content">
                        {bankForm.emailCommissionStatementsTo || "-"}
                      </div>
                    </div>
                    <div className="smRow smFieldFull">
                      <div className="smRowLabel Content-Small">CC</div>
                      <div className="smRowValue Content">
                        {bankForm.emailCommissionStatementsCc || "-"}
                      </div>
                    </div>
                    <div className="smRow smFieldFull">
                      <div className="smRowLabel Content-Small">
                        Statement Password
                      </div>
                      <div className="smRowValue Content">
                        {bankForm.statementPassword
                          ? "Saved"
                          : "-"}
                      </div>
                    </div>
                  </div>
                )}

                {bankMessage ? (
                  <div className="Content-Small muted">{bankMessage}</div>
                ) : null}
                {bankError ? (
                  <div
                    className="Content-Small advLogoDownloadError"
                    role="alert"
                  >
                    {bankError}
                  </div>
                  ) : null}
              </div>
                  <GroupBankDetailsEditLogs groupId={selectedGroup?.GroupId} />
                </>
  );
}
